<script lang="ts" setup>
import type { MetaTags } from "@/types";

defineProps<{ meta: MetaTags }>();

// Generate canonical URL ensuring no trailing slash
const route = useRoute()
const config = useRuntimeConfig()
const canonicalUrl = computed(() => {
  const siteUrl = config.public.siteUrl || 'https://www.smartstone.com.au'
  const path = route.path === '/' ? '' : route.path.replace(/\/+$/, '')
  return `${siteUrl}${path}`
})
</script>

<template>
  <Head>
    <!-- Primary Meta Tags -->
    <Title>{{ meta.title || "Smartstone" }}</Title>
    <Meta v-if="meta.title" name="title" :content="meta.title" />
    <Meta
      v-if="meta.description"
      name="description"
      :content="meta.description"
    />

    <!-- Canonical URL -->
    <Link rel="canonical" :href="canonicalUrl" />

    <!-- Open Graph / Facebook -->
    <Meta property="og:type" content="website" />
    <Meta property="og:url" :content="canonicalUrl" />
    <Meta v-if="meta.og_title" property="og:title" :content="meta.og_title" />
    <Meta
      v-if="meta.og_description"
      property="og:description"
      :content="meta.og_description"
    />
    <Meta v-if="meta.og_image" property="og:image" :content="meta.og_image" />

    <!-- Twitter -->
    <Meta property="twitter:card" content="summary_large_image" />
    <Meta
      v-if="meta.twitter_title"
      property="twitter:title"
      :content="meta.twitter_title"
    />
    <Meta
      v-if="meta.twitter_description"
      property="twitter:description"
      :content="meta.twitter_description"
    />
    <Meta
      v-if="meta.twitter_image"
      property="twitter:image"
      :content="meta.twitter_image"
    />
  </Head>
</template>
